import { defineCopy } from './index';

/** The sync chip in the header and its sheet (outbox status). Short, plain, a little bit of locker room. */
export const syncCopy = defineCopy('sync', {
  waiting: '{n} plays waiting to sync',
  waitingOne: '1 play waiting to sync',
  creates: 'Game waiting to sync',
  syncing: 'Syncing {n}...',
  synced: 'All synced',
  signedOut: 'Signed out. {n} waiting.',
  update: 'Update to sync {n}.',
  install: 'Open the app to sync.',
  rejected: "{n} didn't count",
  rejectedOne: "1 didn't count",
  degraded: 'Not saving. Keep the app open.',
  awake: 'Screen stays on',
  sheet: {
    title: 'Sync',
    open: 'Sync status',
    close: 'Close',
    offline: 'No signal. Everything is saved on this phone and goes up when you are back online.',
    onItsWay: 'On its way. Hang tight.',
    signedOut: 'This phone got signed out. Sign back in and the plays go up. Nothing is lost.',
    update: 'This app is too old for the server. Update it and the plays go up. Nothing is lost.',
    install: 'Open TTS Basketball from your home screen and the plays go up.',
    degraded:
      'This phone would not let us save plays to storage, so they only live in memory. Do not close the app until they sync.',
    allGood: 'Nothing waiting. You are square with the server.',
    turnedDown: 'The server turned some plays down. Nothing else is waiting.',
    syncNow: 'Sync now',
    tryAgain: 'Try again',
    dismiss: 'Dismiss',
    rejectedTitle: "These plays didn't count",
    rejectedLine: '{n} x {why}',
  },
  why: {
    game_locked: 'The game was already final.',
    not_keeper: 'Someone else had the book.',
    bad_target: 'It pointed at a play that is gone.',
    player_not_in_game: 'That player was not in the game.',
    create_failed: 'The game could not be made, so its plays could not count.',
    invalid: 'The server could not read it.',
    other: 'The server said no.',
  },
});
